import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'pluralize',
  pure: false,
  standalone: false
})
export class PluralizePipe implements PipeTransform, OnDestroy {
  private lastValue = '';
  private subscription: Subscription | null = null;

  constructor(
    private readonly translate: TranslateService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  transform(count: number, singularKey: string, pluralKey: string): string {
    const key = count === 1 ? singularKey : pluralKey;

    this.lastValue = `${count} ${this.translate.instant(key)}`;

    this.subscription?.unsubscribe();
    this.subscription = this.translate.stream(key).subscribe((translation) => {
      this.lastValue = `${count} ${translation}`;
      this.cdr.markForCheck();
    });

    return this.lastValue;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
